import L from 'leaflet';
import { getHullPolygons, HULL_MODE_KEY } from './convexHull';

/**
 * Returns the obstacle list to render as individual markers.
 * When hull mode is active the markers are suppressed — only the hull polygon shows.
 */
export function getObstaclesToRender(obstacles, projectId, showObstacles) {
    if (!showObstacles) return [];
    if (localStorage.getItem(HULL_MODE_KEY(projectId)) === 'true') return [];
    return obstacles;
}

/**
 * If hull mode is active for this project, draws one dashed polygon per
 * same-named obstacle group (≥3 points) onto the Leaflet map and pushes
 * each layer into layersRef.current so callers can clean up on re-render.
 *
 * @param {object}   map        - Leaflet map instance
 * @param {array}    obstacles  - raw (non-hull-expanded) obstacle list
 * @param {any}      projectId  - project id (used to look up localStorage flag)
 * @param {object}   layersRef  - React ref whose .current is the layers array
 * @param {function} [wrapFn]   - optional fn(layer, idx) → entry to push;
 *                                use (l, i) => ({ key: `hull_${i}`, layer: l })
 *                                for pages that store { key, layer } objects.
 */
export function addHullPolygonsToMap(map, obstacles, projectId, layersRef, wrapFn) {
    if (!map || localStorage.getItem(HULL_MODE_KEY(projectId)) !== 'true') return;
    let idx = 0;
    getHullPolygons(obstacles).forEach(({ name, points, maxElev, count }) => {
        const latLngs = points.map(p => [p.lat, p.lng]);
        const poly = L.polygon(latLngs, {
            color: '#f5a623',
            weight: 2,
            dashArray: '6 4',
            fillColor: '#f5a623',
            fillOpacity: 0.08,
        });
        poly.bindPopup(
            `<b>⬡ Hull: ${name}</b><br/>` +
            `${count} corner point${count !== 1 ? 's' : ''}<br/>` +
            `Max elevation: ${maxElev} m<br/>` +
            `${points.length} hull vertices`
        );
        poly.bindTooltip(`⬡ ${name}`, { permanent: false, direction: 'center' });
        poly.addTo(map);
        if (layersRef?.current) {
            layersRef.current.push(wrapFn ? wrapFn(poly, idx) : poly);
        }
        idx++;
    });
}
